import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import instance from "../utils/api_instance.util";
import { errorToastify } from "../utils/toastify.util";

const initialState = {
	isLoader: false,
	gameList: [],
	gameDetails: null,
	gameItems: null,
	gamePrizes: null
};

export const getGameList = createAsyncThunk(
	"game/gameList",
	async (payload) => {
		try {
			const { data } = await instance.post(`/api/v1/game/game-list`, payload);
			return data;
		} catch (err) {
			const { data } = err.response;
			errorToastify(data.message);
		}
	}
);

export const getGameItemList = createAsyncThunk(
	"game/getGameItemList",
	async (payload) => {
		try {
			const { data } = await instance.post(`/api/v1/game/hunt-item-list`, payload);
			return data;
		} catch (err) {
			const { data } = err.response;
			errorToastify(data.message);
		}
	}
);

const gameSlice = createSlice({
	name: "game",
	initialState,
	reducers: {
		setGameDetails: (state, { payload }) => {
			state.gameDetails = payload;
		},
		setGameItems: (state, { payload }) => {
			state.gameItems = payload;
		},
		setGamePrizes: (state, { payload }) => {
			state.gamePrizes = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getGameList.pending, (state, action) => {
			state.isLoader = true;
		});
		builder.addCase(getGameList.fulfilled, (state, action) => {
			if (action.payload?.success || false) {
				state.isLoader = false;
				state.gameList = action.payload.result;
			} else {
				state.isLoader = false;
				state.gameList = [];
			}
		});

		builder.addCase(getGameItemList.pending, (state, action) => {
			state.gameItems = [];
		});
		builder.addCase(getGameItemList.fulfilled, (state, action) => {
			if (action.payload?.success || false) {
				state.gameItems = action.payload.result;
			} else {
				state.gameItems = [];
			}
		});
	},
})

export default gameSlice.reducer;
export const { setGameDetails, setGameItems, setGamePrizes } = gameSlice.actions;